import { NextPage } from 'next';
import { NextRouter, useRouter } from 'next/router';

import ConsumptionPage from 'src/components/consumptionPage';
import { ContentTypes } from 'src/components/thumbnail/types';

const Latest1EpisodeConsumptionPage: NextPage<any> = () => {
  const router = useRouter();
  const { locale, asPath }: NextRouter = router;
  const showId = asPath?.split('/')[asPath?.split('/').length - 2];
  return (
    <ConsumptionPage
      pageDetails={{
        showId: showId,
        locale: locale as string,
        contentType: ContentTypes.tvshows,
        isLatest1Route: true
      }}
    />
  );
};
export async function getServerSideProps() {
  return {
    props: {}
  };
}
export default Latest1EpisodeConsumptionPage;
